module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card-content', {
    staticClass: "ql-cue-body"
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.keyPress($event)
      }
    }
  }, [_c('md-input-container', [_c('md-textarea', {
    model: {
      value: (_vm.cue.description),
      callback: function($$v) {
        _vm.$set(_vm.cue, "description", $$v)
      },
      expression: "cue.description"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.done
    }
  }, [_vm._v("Done")])], 1), _vm._v(" "), (_vm.editable) ? _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "cue-description",
    on: {
      "click": _vm.edit
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cue.description),
      expression: "cue.description"
    }]
  }, [_vm._v(_vm._s(_vm.cue.description))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cue.description),
      expression: "!cue.description "
    }]
  }, [_vm._v("Click to enter text")]), _vm._v(" "), (_vm.editable) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Click Text to Edit")]) : _vm._e()], 1) : _c('p', {
    staticClass: "cue-description"
  }, [_c('span', [_vm._v(_vm._s(_vm.cue.description))])]), _vm._v(" "), (!_vm.locked && !_vm.editing && _vm.editable) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.destroy
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete Cue")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5f1c1d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/cue-body.vue
// module id = 683
// module chunks = 2